import { render, staticRenderFns } from "./AdminItem.vue?vue&type=template&id=39196cdc&scoped=true"
import script from "./AdminItem.vue?vue&type=script&lang=ts"
export * from "./AdminItem.vue?vue&type=script&lang=ts"
import style0 from "./AdminItem.vue?vue&type=style&index=0&id=39196cdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39196cdc",
  null
  
)

export default component.exports